import { useEffect, useState } from "react";
import {
  getRegionPin,
  setRegionPin as persistRegionPin,
  type RegionPin,
} from "../config/backend";
import { servedRegionService } from "../services/servedRegionService";

/**
 * Tracks which AWS region is actually serving the current GA-routed backend
 * API, plus exposes the "region pin" override.
 *
 * Reads from servedRegionService — pumped by the existing 30s announcement
 * poll in ChatInterface, which already hits a GA-routed endpoint and
 * therefore already carries the `X-Served-Region` header that TRAC-450's
 * backend middleware stamps on every response. No dedicated /health poll.
 *
 * Refresh cadence is 30s (announcement poll cadence) instead of the prior
 * 15s — fine for a debug widget. ALB liveness checks against /health are
 * unaffected; this only stops the frontend from polling it.
 *
 * `pinned` reflects the localStorage override; `setPinned` writes and
 * reloads so getBackendApiUrl() (module-scoped constant) re-evaluates.
 */
export function useServedRegion() {
  const [region, setRegion] = useState<string | null>(servedRegionService.get());
  const pinned: RegionPin = getRegionPin();

  useEffect(() => {
    return servedRegionService.subscribe(setRegion);
  }, []);

  return { region, pinned, setPinned: persistRegionPin };
}
